import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'campus-dummy',
  template: '',
})
export class DummyComponent {}
